<template>
	<div class="flex-grow-1">
		<v-btn
			aria-label="Toggle requirement form"
			color="black"
			dark
			depressed
			tile
			:height="breakpoint === 'xs' ? 56 : 36"
			:block="breakpoint === 'xs'"
			@click="toggleForm"
		>
			<v-icon
				left
				:large="breakpoint === 'xs'"
				:class="{'mr-4': breakpoint === 'xs'}"
			>
				{{ breakpoint === 'xs' ? 'mdi-home-circle' : 'mdi-menu' }}
			</v-icon>
			<b>ฝากความต้องการซื้ออสังหาฯ</b>
		</v-btn>
		<v-menu
			v-model="widgetActive"
			attach="header"
			:nudge-right="widgetX"
			:nudge-bottom="widgetY"
			:min-width="widgetWidth"
			:max-width="widgetWidth"
			:max-height="widgetHeight"
			:close-on-content-click="false"
		>
			<!-- <v-sheet
				class="d-md-none py-3 text-center"
				style="border-radius: 0; border-bottom: solid 1px #eee;"
			>
				<h4 class="red--text">
					<v-icon class="red--text">
						mdi-cards-heart
					</v-icon>
					รายการโปรด
				</h4>
				<div class="ml-7">
					<b>{{ favoriteList.length }}</b>
					รายการ
				</div>
			</v-sheet> -->

			<v-overlay
				absolute
				:value="overlay"
			>
				<v-card
					class="mx-auto"
					max-width="375"
					outlined
				>
					<v-card-text>
						<p :class="`h5 ${ alertError ? 'red' : 'teal' }--text accent-3`">
							{{ alertError ? 'พบความผิดพลาด' : 'ทำรายการสำเร็จ' }}
						</p>
						{{ alertText }}
					</v-card-text>

					<v-card-actions>
						<v-btn
							class="ml-auto"
							outlined
							text
							@click="overlayCallback"
						>
							ตกลง
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-overlay>

			<favoriteProps
				toward="center"
				list-width="auto"
			>
				<template #default="on">
					<v-sheet
						class="d-md-none py-3 text-center"
						style="border-radius: 0; border-bottom: solid 1px #eee;"
						v-on="on"
					>
						<h4 class="red--text">
							<v-icon class="red--text">
								mdi-cards-heart
							</v-icon>
							รายการโปรด
						</h4>
						<div class="ml-7">
							<b>{{ favoriteList.length }}</b>
							รายการ
						</div>
					</v-sheet>
				</template>
			</favoriteProps>

			<v-card
				classs="py-6 px-10"
				:class="{ 'red-bottom-border': ['xs','sm'].includes(breakpoint) }"
				tile
			>
				<v-row class="py-6 px-10">
					<v-col
						cols="12"
						md="4"
					>
						<h3>ฝากความต้องการซื้ออสังหาริมทรัพย์</h3>
						<p>
							เพียงกรอกข้อมูลเล็กน้อย ก็ไม่พลาดอสังหาฯ ที่ใช่ ระบบจะส่ง SMS แจ้งคุณทันที เมื่อเราพบอสังหาฯ ที่ตรงกับความต้องการของคุณ
						</p>

						<div class="align-center d-flex d-md-block">
							<div>
								<h4 class="red--text">
									<v-icon class="red--text">
										mdi-message-processing-outline
									</v-icon>
									สอบถามข้อมูล
								</h4>
							</div>
							<div class="ml-4 mt-md-4">
								<div class="d-flex">
									<v-btn
										class="ml-2"
										color="grey darken-3"
										href="tel:020474282"
										title="ติดต่อ The Best Property ทางโทรศัพท์ โทร 02-047-4282"
										fab
										dark
										large
									>
										<v-icon>mdi-phone</v-icon>
									</v-btn>
									<v-btn
										class="ml-2"
										color="green"
										href="https://line.me/ti/p/@thebestproperty"
										title="ไลท์แชทกับ The Best Property  ไอดี @thebestproperty"
										target="_blank"
										fab
										dark
										large
									>
										<img
											src="/images/2.0/icon/line.png"
											alt="line"
										>
									</v-btn>
								</div>
							</div>
						</div>

						<favoriteProps toward="right">
							<template #default="on">
								<v-sheet
									class="fav-sheet d-none d-md-block mt-6 py-3 pl-5 pr-9"
									:rounded="false"
									v-on="on"
								>
									<h4 class="red--text">
										<v-icon class="red--text">
											mdi-cards-heart
										</v-icon>
										รายการโปรด
									</h4>
									<div class="ml-7">
										<b>{{ favoriteList.length }}</b>
										รายการ
									</div>
								</v-sheet>
							</template>
						</favoriteProps>
					</v-col>

					<v-col
						cols="12"
						md="8"
						class="flex-grow-1"
					>
						<v-form
							ref="requirementForm"
							v-model="requirementForm"
							lazy-validation
						>
							<v-row>
								<v-col
									cols="12"
									md="5"
									class="py-1"
								>
									<label><b>ชื่อและนามสกุล *</b></label>
									<v-text-field
										v-model="customerName"
										class="input-text-field mt-1"
										placeholder="ใส่ชื่อและนามสกุล *"
										:rules="[v => !!v || 'จำเป็นต้องระบุชื่อของคุณ']"
										dense
										solo
										flat
										required
									/>
								</v-col>
								<v-col
									cols="12"
									md="7"
									class="py-1"
								>
									<label><b>หมายเลขโทรศัพท์เพื่อรับการแจ้งเตือน SMS *</b></label>
									<v-text-field
										v-model="customerPhone"
										class="input-text-field mt-1"
										placeholder="กรอกหมายเลขโทรศัพท์ของคุณ *"
										:rules="[v => !!v || 'จำเป็นต้องระบุหมายเลขโทรศัพท์', v => (v && /[\d]{10}/.test(v)) || 'เบอร์โทรศัพท์ไม่ถูกต้อง']"
										dense
										solo
										flat
										required
										@keyup="phoneFormat"
									/>
								</v-col>

								<v-col
									cols="12"
									class="py-1"
								>
									<v-menu
										v-model="locationActive"
										nudge-bottom="1"
										offset-y
										bottom
										right
										:position-x="locationX"
										:position-y="locationY"
										:close-on-content-click="false"
									>
										<v-card>
											<v-stepper v-model="locationStep">
												<v-stepper-items>
													<v-stepper-content
														class="location-select-panel pa-0"
														step="1"
													>
														<v-btn
															text
															tile
															width="100%"
															class="justify-start"
															@click="provinceClicked(null); locationActive = false;"
														>
															ทุกจังหวัด
														</v-btn>
														<v-divider />

														<div
															v-for="province in location"
															:key="province.p"
															:class="(provinceSelected !== province ? 'province-panel' : 'province-panel location-selected')"
															@click="provinceClicked(province)"
														>
															{{ province.n }}
														</div>
													</v-stepper-content>

													<v-stepper-content
														class="location-select-panel pa-0"
														step="2"
													>
														<v-btn
															text
															tile
															width="100%"
															class="justify-start"
															@click="locationStep = 1"
														>
															เลือกจังหวัดอื่น
														</v-btn>
														<v-btn
															text
															tile
															width="100%"
															class="justify-start"
															@click="districtClicked(null)"
														>
															อำเภอ / เขต ทั้งหมด
														</v-btn>
														<v-divider />

														<div
															v-for="district in provinceSelected ? provinceSelected.v : []"
															:key="district.d"
															@click="districtClicked(district)"
														>
															<div
																:class="(districtSelected.indexOf(district) < 0 ? 'district-panel' : 'district-panel location-selected')"
															>
																<v-checkbox
																	color="white"
																	hide-details
																	:dark="districtSelected.indexOf(district) >= 0"
																	:input-value="districtSelected.indexOf(district) >= 0"
																	:label="district.n"
																/>
															</div>
															<div
																v-if="districtSelected.indexOf(district) > -1"
																class="sub-district-panel"
															>
																<div
																	v-for="subDistrict in district.v"
																	:key="subDistrict.s"
																	:class="subDistrictSelected.indexOf(subDistrict) < 0 ? 'location-options' : 'location-options location-selected'"
																	@click.stop="subDistrictClicked(subDistrict)"
																>
																	<input
																		type="checkbox"
																		:checked="subDistrictSelected.indexOf(subDistrict) >= 0"
																	> {{ subDistrict.n }}
																</div>
															</div>
														</div>
													</v-stepper-content>
												</v-stepper-items>
											</v-stepper>
										</v-card>
									</v-menu>

									<v-radio-group
										v-model="reqType"
										hide-details
									>
										<v-radio
											label="ชื่อโครงการ"
											color="red"
											value="project"
											class="mt-4 mb-3"
										/>
									</v-radio-group>
									<label :class="{'text--disabled': reqType !== 'project'}">
										<b>ชื่อโครงการ</b>
									</label>
									<v-text-field
										v-model="project"
										class="input-text-field mt-1"
										placeholder="ชื่อโครงการ"
										hide-details
										dense
										solo
										flat
									/>
									<v-combobox
										v-model="locationQueryText"
										:items="locationAcItems"
										:loading="locationAcLoading"
										:search-input.sync="locationText"
										:menu-props="{ maxWidth: 400 }"
										:hide-no-data="useLocation || locationActive"
										:disabled="reqType !== 'project'"
										hide-details
										no-filter
										solo
										flat
										dense
										color="red"
										heights="36"
										class="input-text-field mt-1 d-none"
										label="ชื่อโครงการ"
										item-text="name"
										item-value="name"
										append-icon=""
										@keydown.native="locationInputQuery"
										@focus="acQuery(locationText)"
									>
										<!-- <template
											v-if="(locationText || '').trim() === ''"
											v-slot:no-data
										>
											<v-list-item @click="locationShow">
												<v-list-item-title>
													<div style="color: red;">
														เลือกจังหวัด อำเภอ ตำบล
													</div>
												</v-list-item-title>
											</v-list-item>
										</template> -->
										<template v-slot:item="{ parent, item }">
											<template v-if="typeof item !== 'object'">
												<v-list-item-content v-text="item" />
											</template>
											<template v-else>
												<v-list-item-content @click="useLocation = false">
													<!-- eslint-disable vue/no-v-html -->
													<v-list-item-title v-html="filteredText(parent.searchInput, item.name)" />
													<v-list-item-subtitle v-html="filteredText(parent.searchInput, item.address)" />
													<!-- eslint-enable vue/no-v-html -->
												</v-list-item-content>
												<v-list-item-action>{{ item.category }}</v-list-item-action>
											</template>
										</template>
									</v-combobox>
								</v-col>

								<v-col
									cols="12"
									class="py-0"
								>
									<v-radio-group
										v-model="reqType"
										hide-details
									>
										<v-radio
											label="ทำเลที่ตั้ง"
											color="red"
											value="location"
											class="mt-4 mb-3"
										/>
									</v-radio-group>
								</v-col>

								<v-col
									cols="12"
									md="4"
									class="py-1"
								>
									<label :class="{'text--disabled': reqType !== 'location'}">
										<b>เลือกประเภท</b>
									</label>
									<v-btn
										ref="useForBtn"
										outlined
										tile
										width="100%"
										height="46"
										class="btn-menu text-left mt-1 px-2"
										:title="useForText"
										:disabled="reqType !== 'location'"
										@click="useForShow"
									>
										<v-row no-gutters>
											<v-col
												class="flex-grow-1"
												style="width: 0;"
											>
												{{ useForText }}
											</v-col>
											<v-col class="flex-grow-0 flex-shrink-1">
												<v-icon color="grey lighten-1">
													mdi-menu-swap-outline
												</v-icon>
											</v-col>
										</v-row>
									</v-btn>
									<v-menu
										v-model="useForActive"
										nudge-bottom="1"
										offset-y
										bottom
										right
										:position-x="useForX"
										:position-y="useForY"
										:close-on-content-click="false"
									>
										<v-card>
											<v-tabs
												v-model="useForTab"
												color="red"
											>
												<v-tab
													href="#ALL"
													@click="useForVal = 'ALL'"
												>
													ทุกประเภท
												</v-tab>
												<v-tab
													href="#REST"
													@click="useForVal = 'REST'"
												>
													ที่อยู่อาศัย
												</v-tab>
												<v-tab
													href="#COMMERCIAL"
													@click="useForVal = 'COMMERCIAL'"
												>
													เชิงพาณิชย์
												</v-tab>
											</v-tabs>

											<v-tabs-items v-model="useForTab">
												<v-tab-item
													value="ALL"
													class="pt-2 black--text"
												>
													<div
														v-for="item in useForRestItems"
														:key="'ALL_' + item.value"
													>
														<v-checkbox
															v-model="useForSelected"
															class="px-4 pb-3"
															color="red"
															:label="item.text"
															:value="item.value"
															hide-details
															dense
														/>
													</div>

													<div
														v-for="item in useForCommercialItems"
														:key="'ALL_' + item.value"
													>
														<v-checkbox
															v-model="useForSelected"
															class="px-4 pb-3"
															color="red"
															:label="item.text"
															:value="item.value"
															hide-details
															dense
														/>
													</div>
												</v-tab-item>

												<v-tab-item value="REST">
													<div
														v-for="item in useForRestItems"
														:key="item.value"
														:class="item.value === useForVal ? 'bgGrey' : ''"
													>
														<v-btn
															text
															tile
															width="100%"
															class="justify-start"
															@click="useForVal = item.value; useForActive = false;"
														>
															{{ item.text }}
														</v-btn>
													</div>
												</v-tab-item>

												<v-tab-item value="COMMERCIAL">
													<div
														v-for="item in useForCommercialItems"
														:key="item.value"
														:class="item.value === useForVal ? 'bgGrey' : ''"
													>
														<v-btn
															:value="item.value"
															text
															tile
															width="100%"
															class="justify-start"
															@click="useForVal = item.value; useForActive = false;"
														>
															{{ item.text }}
														</v-btn>
													</div>
												</v-tab-item>
											</v-tabs-items>
										</v-card>
									</v-menu>
								</v-col>

								<v-col
									cols="12"
									md="8"
									class="py-1"
								>
									<label :class="{'text--disabled': reqType !== 'location'}">
										<b>จังหวัด</b>
									</label>
									<v-btn
										ref="locationBtn"
										outlined
										tile
										width="100%"
										height="46"
										class="btn-menu text-left mt-1 px-2"
										:title="refLocationText"
										:disabled="reqType !== 'location'"
										@click="locationShow"
									>
										<v-row no-gutters>
											<v-col
												class="flex-grow-1"
												style="width: 0;"
											>
												{{ refLocationText }}
											</v-col>
											<v-col class="flex-grow-0 flex-shrink-1">
												<v-icon color="grey lighten-1">
													mdi-menu-swap-outline
												</v-icon>
											</v-col>
										</v-row>
									</v-btn>
								</v-col>

								<v-col
									cols="12"
									class="py-1"
								>
									<label><b>ระบุช่วงราคา</b></label>
									<v-btn
										ref="priceBtn"
										outlined
										tile
										width="100%"
										height="46"
										class="btn-menu text-left mt-1 px-2"
										:title="priceText"
										@click="priceShow"
									>
										<v-row no-gutters>
											<v-col
												class="flex-grow-1"
												style="width: 0;"
											>
												{{ priceText }}
											</v-col>
											<v-col class="flex-grow-0 flex-shrink-1">
												<v-icon color="grey lighten-1">
													mdi-menu-swap-outline
												</v-icon>
											</v-col>
										</v-row>
									</v-btn>
									<v-menu
										v-model="priceActive"
										nudge-bottom="1"
										offset-y
										bottom
										right
										:position-x="priceX"
										:position-y="priceY"
										:close-on-content-click="false"
									>
										<v-card class="price-options">
											<v-row
												no-gutters
												class="flex-nowrap"
											>
												<v-text-field
													v-model="priceMin"
													placeholder="ต่ำสุด"
													dense
													class="input-center flex-grow-1"
													@focus="hideMinPrice = false"
												/>
												<div class="flex-grow-0">
													-
												</div>
												<v-text-field
													v-model="priceMax"
													placeholder="สูงสุด"
													dense
													class="input-center flex-grow-1"
													@focus="hideMinPrice = true"
												/>
											</v-row>

											<div :class="hideMinPrice ? 'd-none' : ''">
												<div>
													<v-btn
														text
														tile
														width="100%"
														class="justify-start"
														@click="priceMin = ''; hideMinPrice = true;"
													>
														ไม่ระบุ
													</v-btn>
												</div>
												<v-divider />
												<div
													v-for="price in priceItems"
													:key="'min-' + price"
													:class="!!price && !!priceMin && price.toString() === priceMin.toString() ? 'bgGrey' : ''"
												>
													<v-btn
														text
														tile
														width="100%"
														class="justify-start"
														:disabled="priceMax != '' && price > priceMax"
														@click="priceMin = price; hideMinPrice = true;"
													>
														{{ new Intl.NumberFormat('th-TH').format(price) }} บาท
													</v-btn>
												</div>
											</div>

											<div>
												<div>
													<v-btn
														text
														tile
														width="100%"
														class="justify-end"
														@click="priceMax = ''; priceActive = false;"
													>
														ไม่ระบุ
													</v-btn>
												</div>
												<v-divider />
												<div
													v-for="price in priceItems"
													:key="'max-' + price"
													:class="!!price && !!priceMax && price.toString() === priceMax.toString() ? 'bgGrey' : ''"
												>
													<v-btn
														text
														tile
														width="100%"
														class="justify-end"
														:disabled="price < priceMin"
														@click="priceMax = price; priceActive = false;"
													>
														{{ new Intl.NumberFormat('th-TH').format(price) }} บาท
													</v-btn>
												</div>
											</div>
										</v-card>
									</v-menu>
								</v-col>

								<v-col
									cols="12"
									class="py-1"
								>
									<label><b>รายละเอียดเพิ่มเติม</b></label>
									<v-textarea
										v-model="additionalDetail"
										class="input-text-field mt-1"
										hide-details
										dense
										solo
										flat
									/>
								</v-col>

								<v-col
									cols="12"
									class="d-flex mt-4 py-0 mt-lg-2"
								>
									<v-btn
										color="grey lighten-2"
										:disabled="loading"
										depressed
										tile
										@click="clearCiteria"
									>
										ล้างข้อมูล
									</v-btn>
									<v-btn
										class="btn-red-gradient white--text flex-grow-1 flex-md-grow-0"
										:loading="loading"
										:disabled="loading"
										depressed
										tile
										@click="submitQuery();"
									>
										ส่งข้อความ
									</v-btn>
									<v-btn
										class="triangle-botleft btn-black-gradient white--text flex-grow-0 flex-shrink-1"
										:disabled="loading"
										depressed
										tile
										@click="submitQuery();"
									>
										<v-icon>
											mdi-arrow-right
										</v-icon>
									</v-btn>
								</v-col>
							</v-row>
						</v-form>
					</v-col>
				</v-row>
			</v-card>
		</v-menu>
	</div>
</template>

<script>

import favoriteProps from '~/components/favorite-props'
import { mapActions, mapGetters } from 'vuex'
const configSearch = require('~/plugins/config-search')

export default {
	components: {
		favoriteProps,
	},

	props: {
		params: {
			type: Object,
			default: () => ({})
		}
	},

	data() {
		return {
			loading: false,
			timer: null,

			alertError: false,
			alertText: '',
			overlay: false,
			overlayCallback: null,

			query: {},
			widgetActive: false,
			widgetX: 0,
			widgetY: 0,

			fav: true,
			menu: false,
			hints: true,

			garageCount: '',
			bedroomCount: '',
			toiletCount: '',

			requirementForm: true,
			reqType: 'project',
			project: '',
			customerName: '',
			customerPhone: '',
			additionalDetail: '',

			/**
			 * Location options
			 */
			locationX: 0,
			locationY: 0,
			locationActive: false,
			useLocation: false,
			locationStep: 1,
			provinceSelected: null,
			districtSelected: [],
			subDistrictSelected: [],
			locationText: '',

			/**
			 * Location AC
			 */
			locationQueryText: '',
			locationAcItems: [],
			locationAcLoading: false,

			/**
			 * Property tx options
			 */
			txOptionSelected: 'BUY',
			txOption: configSearch.txOption,

			/**
			 * 'Use for' options
			 */
			useForX: 0,
			useForY: 0,
			useForActive: false,
			useForTab: 'ALL',
			useForVal: 'ALL',
			useForSelected: [
				// ...configSearch.useForRestItems.map(item => item.value),
				// ...configSearch.useForCommercialItems.map(item => item.value)
			],
			useForRestItems: configSearch.useForRestItems,
			useForCommercialItems: configSearch.useForCommercialItems,

			/**
			 * Price options
			 */
			priceX: 0,
			priceY: 0,
			hideMinPrice: false,
			priceActive: false,
			priceMin: '',
			priceMax: '',
			priceItems: configSearch.priceItems,

			/**
			 * More filter: Announce time
			 */
			announceTimeSelected: null,
			announceTime: configSearch.announceTime,

			/**
			 * More filter: Useful space size
			 */
			hideMinUseful: false,
			usefulSpaceActive: false,
			usefulSpaceMin: '',
			usefulSpaceMax: '',
			usefulSpaceItems: configSearch.usefulSpaceItems,

			/**
			 * More filter: Area space size
			 */
			hideMinArea: false,
			areaSpaceActive: false,
			areaSpaceMin: '',
			areaSpaceMax: '',
			areaSpaceItems: configSearch.areaSpaceItems,

			/**
			 * More filter: Property direction
			 */
			propertyDirectionSelected: null,
			propertyDirection: configSearch.propertyDirection,

			/**
			 * More filter: Created date
			 */
			datePickerMenu: false,
			datePick: null,

			paramMap: {
				reqType: 'by',
				customerName: 'customer_name',
				customerPhone: 'customer_phone',
				additionalDetail: 'additional_detail',
				project: 'text',
				provinceSelected: 'province',
				districtSelected: 'district',
				subDistrictSelected: 'sub_district',
				// txOptionSelected: 'tx',
				useForVal: 'market',
				priceMin: 'minprice',
				priceMax: 'maxprice',
				bedroomCount: 'minbeds',
				toiletCount: 'minbath',
				garageCount: 'mingarage',
				propertyDirectionSelected: 'direction',
				usefulSpaceMin: 'minsize',
				usefulSpaceMax: 'maxsize',
				areaSpaceMin: 'minlandsize',
				areaSpaceMax: 'maxlandsize',
				announceTimeSelected: 'latest',
				datePick: 'published_date'
			}
		}
	},

	computed: {
		...mapGetters({
			location: 'location',
			searchToggle: 'page/searchToggle',
			favoriteList: 'property/favoriteList',
		}),

		breakpoint () {
			return this.$vuetify.breakpoint.name
		},

		widgetWidth () {
			return ['xl','lg'].includes(this.breakpoint) ? 1161 : this.breakpoint === 'md' ? 876 : '100%'
		},

		widgetHeight () {
			let rect = document.querySelector('.v-toolbar__content')?.getBoundingClientRect() || { bottom: 56 }

			return document.defaultView.screen.height - rect.bottom
		},

		refLocationText () {
			let text = 'ไม่ระบุ'
			if (typeof this.locationQueryText === 'string' && this.provinceSelected) {
				text = this.locationQueryText
			} else if (typeof this.locationQueryText === 'object') {
				if (['province', 'district', 'subdistrict'].indexOf(this.locationQueryText?.type) !== -1) {
					text = this.locationQueryText.name
				}
			}

			return text
		},

		priceText () {
			let text = 'ไม่ระบุ'
			if(this.priceMin === '') {
				text = 'สูงสุด '
				if(this.priceMax === '') {
					text = 'ไม่จำกัดราคา'
				} else {
					text += new Intl.NumberFormat('th-TH').format(this.priceMax) + ' บาท'
				}
			} else {
				text = new Intl.NumberFormat('th-TH').format(this.priceMin)
				if(this.priceMax === '') {
					text = 'เริ่มต้น ' + text + ' บาท'
				} else {
					text += ' - ' + new Intl.NumberFormat('th-TH').format(this.priceMax) + ' บาท'
				}
			}

			return text
		},

		useForText () {
			let text = 'ไม่ระบุ'
			if (this.useForVal === 'REST') {
				text = 'ที่อยู่อาศัย'
			} else if (this.useForVal === 'COMMERCIAL') {
				text = 'เชิงพาณิชย์'
			} else if (this.useForVal === 'ALL') {
				if (this.useForSelected.length <= (this.useForRestItems.length + this.useForCommercialItems.length) && this.useForSelected.length > 0) {
					text = `เลือก ${this.useForSelected.length} ประเภท`
				}
			} else {
				for (let item of [...this.useForRestItems, ...this.useForCommercialItems]) {
					if (this.useForVal === item.value) {
						text = item.text
						break
					}
				}
			}

			return text
		},

		usefulSpaceText () {
			let text = ''
			if(this.usefulSpaceMin === '') {
				text = 'สูงสุด '
				if(this.usefulSpaceMax === '') {
					text = 'ไม่ระบุ'
				} else {
					text += new Intl.NumberFormat('th-TH').format(this.usefulSpaceMax) + 'm²'
				}
			} else {
				text = new Intl.NumberFormat('th-TH').format(this.usefulSpaceMin)
				if(this.usefulSpaceMax === '') {
					text = 'ไม่น้อยกว่า ' + text + 'm²'
				} else {
					text += ' - ' + new Intl.NumberFormat('th-TH').format(this.usefulSpaceMax) + 'm²'
				}
			}

			return text
		},

		areaSpaceText () {
			let text = ''
			if(this.areaSpaceMin === '') {
				text = 'สูงสุด '
				if(this.areaSpaceMax === '') {
					text = 'ไม่ระบุ'
				} else {
					text += new Intl.NumberFormat('th-TH').format(this.areaSpaceMax) + 'm²'
				}
			} else {
				text = new Intl.NumberFormat('th-TH').format(this.areaSpaceMin)
				if(this.areaSpaceMax === '') {
					text = 'ไม่น้อยกว่า ' + text + 'm²'
				} else {
					text += ' - ' + new Intl.NumberFormat('th-TH').format(this.areaSpaceMax) + 'm²'
				}
			}

			return text
		}
	},

	watch: {
		locationText (newVal) {
			this.acQuery(newVal)
		},

		/*
		useForSelected (newVal) {
			if (newVal.length === 0) {
				this.useForSelected = [
					...this.useForRestItems.map(item => item.value),
					...this.useForCommercialItems.map(item => item.value)
				]
			}
		},
		*/

		searchToggle () {
			this.widgetActive = true
		},

		params () {
			// Ordering param is outside this component
			this.query.order = this.params.order
		}
	},

	mounted () {
		// Need to extract (or clone) object (else it will reference to passing var)
		this.initCriteria({ ...this.params })
	},

	methods: {
		...mapActions({
			locationQuery: 'property/locationQuery'
		}),

		initCriteria (params = {}) {
			if (params) {
				this.query = params
			}

			let key, param, p, d
			for (key in this.paramMap) {
				param = this.paramMap[key]
				if (this.query[param]) {
					if (key === 'provinceSelected') {
						p = this.location.find(p => p.p.toString() === this.query[param].toString())
						this[key] = p
						this.useLocation = true
					} else if (p && key === 'districtSelected') {
						// In case of 1 selected, need to convert to array
						if (typeof this.query[param] !== 'object') {
							this.query[param] = [ this.query[param] ]
						}
						d = p.v.filter(d => this.query[param].findIndex(x => x.toString() === d.d.toString()) > -1)
						this[key] = d
					} else if (p && d && key === 'subDistrictSelected') {
						// In case of 1 selected, need to convert to array
						if (typeof this.query[param] !== 'object') {
							this.query[param] = [ this.query[param] ]
						}
						this[key] = []
						for (let x of d) {
							this[key].push(...x.v.filter(s => this.query[param].findIndex(v => v.toString() === s.s.toString()) >= 0))
						}
					} else if (key === 'locationText') {
						if(!p) {
							// this[key] = this.query[param]
							if (this.query['type']) {
								this.locationQueryText = {
									name: this.query[param],
									type: this.query['type']
								}
							} else {
								this.locationQueryText = this.query[param] || ''
							}
						}
					} else {
						this[key] = this.query[param]
					}
				} else if (key === 'useForVal') {
					this[key] = 'ALL'
				} else if (key === 'txOptionSelected') {
					this[key] = 'BUY'
				}
			}

			if (d) {
				this.locationStep = 2
			}
			if (p) {
				this.locationTextChange()
			}

			// Check for active 'use-for' tab
			if (this.useForVal === 'REST' || this.useForRestItems.findIndex(u => u.value === this.useForVal) > -1) {
				this.useForTab = 'REST'
			} else if (this.useForVal === 'COMMERCIAL' || this.useForCommercialItems.findIndex(u => u.value === this.useForVal) > -1) {
				this.useForTab = 'COMMERCIAL'
			} else {
				if (this.query['market_selected']) {
					this.useForTab = 'ALL'
					if (typeof this.query['market_selected'] === 'string') {
						this.useForSelected = [ this.query['market_selected'] ]
					} else {
						this.useForSelected = this.query['market_selected']
					}
				} else {
					this.useForSelected = [
						// ...this.useForRestItems.map(item => item.value),
						// ...this.useForCommercialItems.map(item => item.value)
					]
				}
			}
		},

		filteredText (search, text) {
			if (text) {
				return text.split(search).join(`<span class="highlight">${search}</span>`)
			}
			return ''
		},

		acQuery (text) {
			if (!this.locationActive) {
				this.locationAcItems = []
				if (text && text.length > 2) {

					this.locationAcLoading = true

					// Delay before query
					if (this.timer) {
						clearTimeout(this.timer)
					}
					this.timer = setTimeout(() => {
						this.timer = null
						this.locationQuery(text).then(list => {
							this.locationAcItems = list
						}).catch(err => {
							console.log(err)
						}).finally(() => {
							this.locationAcLoading = false
						})
					}, 1000)
				}
			}
		},

		phoneFormat () {
			this.customerPhone = this.customerPhone.replaceAll(/\D/g, '')
		},

		submitQuery () {
			if (!this.$refs.requirementForm.validate()) {
				return
			}

			let key, param
			for (key in this.paramMap) {
				param = this.paramMap[key]
				if (this[key]) {
					if (Array.isArray(this[key]) && this[key].length === 0) {
						delete this.query[param]
					} else {
						if (key === 'txOptionSelected' && this[key] === 'ALL') {
							delete this.query[param]
						} else if (key === 'provinceSelected') {
							this.query[param] = this[key].p
						} else if (key === 'districtSelected') {
							this.query[param] = this[key].map(d => d.d)
						} else if (key === 'subDistrictSelected') {
							this.query[param] = this[key].map(s => s.s)
						} else if (key === 'locationText') {
							if(!this.provinceSelected) {
								this.query[param] = this[key]
								if (this.locationQueryText.type) {
									this.query['type'] = this.locationQueryText.type
								} else {
									delete this.query['type']
								}
							} else {
								delete this.query[param]
								delete this.query['type']
							}
						} else if (key === 'useForVal') {
							if (this[key] === 'ALL') {
								delete this.query[param]
								if (this.useForSelected.length > 0 && this.useForSelected.length <= (this.useForRestItems.length + this.useForCommercialItems.length)) {
									this.query['market_selected'] = this.useForSelected
								} else {
									delete this.query['market_selected']
								}
							} else  {
								delete this.query['market_selected']
								this.query[param] = this[key]
							}
						} else {
							this.query[param] = this[key]
						}
					}
				} else {
					delete this.query[param]
					if (key === 'locationText') {
						delete this.query['type']
					}
				}
			}

			this.loading = true
			this.$fireFunc.httpsCallable('customer-contact')({
				...this.query,
				source: 'contact-requirement'
			}).then(({data}) => {
				if (data.error) {
					this.alert({
						error: true,
						text: 'ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้งภายหลัง หรือติดต่อผู้ดูแลระบบ',
						callback: () => {
							this.overlay = false
						}
					})
				} else {
					this.alert({
						error: false,
						text: 'เราได้รับคำขอของคุณแล้ว เดอะ เบสท์ พร็อพเพอร์ตี้ เอเจนท์ ขอขอบคุณที่ท่านให้ความสนใจในบริการของเรา เราจะติดต่อกลับท่านโดยเร็วที่สุด',
						callback: () => {
							this.overlay = false
							setTimeout(() => {
								this.widgetActive = false
							}, 300)
						}
					})
				}
			}).catch(() => {
				this.alert({
					error: true,
					text: 'ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้งภายหลัง หรือติดต่อผู้ดูแลระบบ',
					callback: () => {
						this.overlay = false
					}
				})
			}).finally(() => {
				this.$refs.requirementForm.reset()
				this.loading = false
			})
		},

		alert (config) {
			this.alertError = config.error
			this.alertText = config.text
			this.overlayCallback = config.callback || (() => {})
			this.overlay = true
		},

		toggleForm (event) {
			event.preventDefault()
			let rect = document.querySelector('.v-toolbar__content').getBoundingClientRect()
			this.widgetActive = false
			this.widgetY = rect.bottom
			if (this.widgetWidth === '100%') {
				this.widgetX = 0
			} else {
				this.widgetX = (rect.width - this.widgetWidth) / 2
			}
			this.$nextTick(() => {
				this.widgetActive = true
			})
		},

		locationInputQuery () {
			this.provinceSelected = null
			this.districtSelected = null
			this.subDistrictSelected = null
			this.locationActive = false
			this.useLocation = false
			this.locationStep = 1
		},

		locationShow (event) {
			event.preventDefault()
			let rect = this.$refs.locationBtn.$el.getBoundingClientRect()
			this.locationActive = false
			this.locationX = rect.left
			this.locationY = rect.bottom
			this.$nextTick(() => {
				this.locationActive = true
			})
		},

		provinceClicked (province) {
			// Clear query search items
			this.locationAcItems = []

			this.provinceSelected = province

			if(province === null) {
				this.useLocation = false
				this.locationStep = 1
			} else {
				this.useLocation = true
				this.locationStep = 2
			}

			this.districtSelected = []
			this.subDistrictSelected = []
			this.locationTextChange()
		},

		districtClicked (district) {
			if(district !== null) {
				let index = this.districtSelected.indexOf(district)
				if (index < 0) {
					this.districtSelected.push(district)
				} else {
					this.districtSelected.splice(index, 1)
					for (let sd of district.v) {
						index = this.subDistrictSelected.indexOf(sd)
						if (index > -1) {
							this.subDistrictSelected.splice(index, 1)
						}
					}
				}

				this.useLocation = true
			} else {
				this.subDistrictSelected = []
				this.districtSelected = []
				this.locationActive = false
			}

			this.locationTextChange()
		},

		subDistrictClicked (subDistrict) {
			let index = this.subDistrictSelected.indexOf(subDistrict)
			if(index < 0) {
				this.subDistrictSelected.push(subDistrict)
			} else {
				this.subDistrictSelected.splice(index, 1)
			}
			this.useLocation = true
			this.locationTextChange()
		},

		locationTextChange () {
			// this.locationText = (this.provinceSelected ? this.provinceSelected.n : '') + (this.districtSelected ? ', ' + this.districtSelected.n : '')
			this.locationQueryText = (this.provinceSelected ? this.provinceSelected.n : '')
			for(let d of this.districtSelected) {
				this.locationQueryText += ', ' + d.n
			}
			for(let sd of this.subDistrictSelected) {
				// this.locationText += ', ' + sd.n
				this.locationQueryText += ', ' + sd.n
			}
		},

		useForShow (event) {
			event.preventDefault()
			let rect = this.$refs.useForBtn.$el.getBoundingClientRect()
			this.useForActive = false
			this.useForX = rect.left
			this.useForY = rect.bottom
			this.$nextTick(() => {
				this.useForActive = true
			})
		},

		priceShow (event) {
			event.preventDefault()
			let rect = this.$refs.priceBtn.$el.getBoundingClientRect()
			this.priceActive = false
			this.priceX = rect.left
			this.priceY = rect.bottom
			this.$nextTick(() => {
				this.priceActive = true
			})
		},

		numberOptionChanged (min, max, ref) {
			if(this[ref] > max) {
				this[ref] = max
			} else if (this[ref] < min) {
				this[ref] = ''
			}
		},

		clearCiteria () {
			this.$refs.requirementForm.reset()

			this.garageCount = ''
			this.bedroomCount = ''
			this.toiletCount = ''

			/**
			 * Location options
			 */
			this.locationActive = false
			this.useLocation = false
			this.locationStep = 1
			this.provinceSelected = null
			this.districtSelected = []
			this.subDistrictSelected = []
			this.locationText = ''

			this.locationQueryText = ''

			/**
			 * Property tx options
			 */
			this.txOptionSelected = 'BUY'

			/**
			 * 'Use for' options
			 */
			this.useForActive = false
			this.useForTab = 'ALL'
			this.useForVal = 'ALL'
			this.useForSelected = [
				// ...this.useForRestItems.map(item => item.value),
				// ...this.useForCommercialItems.map(item => item.value)
			]

			/**
			 * Price options
			 */
			this.hideMinPrice = false
			this.priceActive = false
			this.priceMin = ''
			this.priceMax = ''

			/**
			 * More filter: Announce time
			 */
			this.announceTimeSelected = null

			/**
			 * More filter: Useful space size
			 */
			this.hideMinUseful = false
			this.usefulSpaceActive = false
			this.usefulSpaceMin = ''
			this.usefulSpaceMax = ''

			/**
			 * More filter: Area space size
			 */
			this.hideMinArea = false
			this.areaSpaceActive = false
			this.areaSpaceMin = ''
			this.areaSpaceMax = ''

			/**
			 * More filter: Property direction
			 */
			this.propertyDirectionSelected = null

			/**
			 * More filter: Created date
			 */
			this.datePick = null

			this.$refs.requirementForm.resetValidation()
		}
	}
}
</script>

<style lang="scss" scoped>
.red-bottom-border {
	border-bottom: solid rgb(237,28,36);
}
.v-menu__content {
	border-radius: 0;
}
.v-item-group {
	&.v-btn-toggle {
		width: 100%;
	}

	& > :not(.v-item--active) {
		box-shadow: inset 0px 0px 5px #bbb;
	}
}
.v-item--active::v-deep {
	background-color: #fff;
	.v-btn__content, .v-list-item__content {
		color: rgb(237,28,36);
	}
}
.fav-sheet {
	border: solid 1px #ddd;
	width: max-content;
}
.search {
	padding: 20px 40px 25px 40px;

	.close-search {
		position: absolute;
    top: 0;
    right: 0px;
    width: 30px;
		height: 30px;

		i {
			font-size: 16px;
		}
	}
	& > .row > .col {
		padding-bottom: 10px;
	}
	.btnSubmit {
		background: #fff;
		border-bottom-right-radius: 7px;
		border-top-right-radius: 7px;
		height: 36px;
		padding-top: 3px;
		text-align: center;
		width: 100%;
		button {
			background: #c20000;
			border-radius: 50%;
			color: #fff;
			height: 30px;
			text-align: center;
			width: 30px;
		}
		i {
			color: #fff;
		}
	}
	&::v-deep .v-input__slot {
		// border-radius: 0;
		margin-bottom: 0;
		min-height: auto;
	}
	.v-select__selections {
		height: 36px;
	}
	&::v-deep .v-text-field__details {
		display: none;
	}
	&::v-deep .v-text-field.v-text-field--solo .v-input__control {
		min-height: auto;
	}
	.v-text-field.v-text-field--solo .v-label {
		left: 15px !important;
	}
	.v-text-field.v-text-field--enclosed .v-text-field__details,
	.v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {
		padding: 0;
	}

	.triangle-botleft:after {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		width: 10px;
		background: rgb(237,28,36);
		background: linear-gradient(180deg, rgba(237,28,36,1) 0%, rgba(233,41,48,1) 50%, rgba(201,37,44,1) 100%);
    clip-path: polygon(-1px 0, 0 0, 100% 100%, -1px 100%);
	}
}

.v-input--selection-controls {
	margin-top: 0;
}

.v-list-item__content::v-deep .highlight {
	color: red;
}

.input-text-field::v-deep .v-input__slot {
	border: solid 1px rgba(0,0,0,0.24);
	border-radius: 0;
	display: inline-block !important;
	text-overflow: ellipsis;
	overflow: hidden;
	width: 100%;

	input {
		min-height: 44px;
	}
}
.location-select {
	border-top-left-radius: 7px;
	border-bottom-left-radius: 7px;
	border-top-right-radius: 0;
	border-bottom-right-radius: 0;
	border-right: 0;
}
.location-select i {
	transform: rotate(-50deg);
}
.location-select-panel {
	width: 300px;
	max-height: 450px;
	overflow-y: auto;
}
.location-selected {
	background-color: #c20000;
	color: #fff;

	&::v-deep label {
		color: #fff !important;
	}
}
.province-panel, .district-panel {
	padding-left: 10px;
	line-height: 34px;

	&:hover {
		cursor: pointer;

		&:not(.location-selected) {
			background-color: #eee;
		}
	}

	&::v-deep label {
		color: #000;
	}
}
.sub-district-panel {
	margin-left: 19px;

	.location-options:hover {
		cursor: pointer;

		&:not(.location-selected) {
			background-color: #eee;
		}
	}

	input[type="checkbox"] {
		margin-right: 4px;
	}
}
.price-options {
	max-height: 300px;
	overflow-y: auto;
}
.input-center::v-deep input {
	text-align: center !important;
}
.btn-menu {
	border-color: rgba(0,0,0,0.24);
}
.btn-menu::v-deep .v-btn__content {
	display: inline-block !important;
	text-overflow: ellipsis;
	overflow: hidden;
	width: 100%;

	:not(.v-icon) {
		font-size: 1rem;
	}
}
.bgGrey {
	background: #eee;
}
</style>
